import React, { Component, Fragment }  from 'react';
import { Button, Navbar, Nav, NavbarToggler, Collapse, NavItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { NavLink, withRouter } from 'react-router-dom';
import { NavLink as RRNavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { userSignout } from '../redux/ActionCreators';
import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
  };
};

// const mapDispatchToProps = (dispatch) => ({
//   userSignout: () => {dispatch(userSignout())}
// });

class Header extends Component {
    constructor(props){
        super(props);
        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            isBuilderDropdownOpen: false
        };
        this.toggleNav = this.toggleNav.bind(this);
        // this.handleLogout = this.handleLogout.bind(this); 
    }

    toggleNav(){
        this.setState({
            isNavOpen: !this.state.isNavOpen
        });
        }

    // async handleLogout() {
    //     await Auth.signOut();
    //     window.location.replace(window.location.origin);
    //     this.props.userSignout();
    // }

    render(){
        const { location } = this.props;
        return(
            <div className="container-fluid px-0">            
                <div className="row align-items-center topbar">
                    <div className="col-auto d-flex align-items-center" style={{ marginLeft: '32px' }}>
                      <img 
                        src={require('../shared/sura_logo.png')} 
                        style={{ filter: 'invert(1)', width: '200px' }} 
                        alt="sura" 
                      />
                    </div>
                    <div className="col d-flex justify-content-end align-items-center">
                      <img 
                        src={require('../shared/SUR_Quantim_HWeb_Positivo.png')} 
                        alt="quantim" 
                        style={{ width: '200px' }}
                      />
                    </div>
                </div>

                <div className="row bg-nav align-items-center position-relative" style={{ minHeight: '64px' }}>
                    <div className="col-auto d-flex align-items-center" style={{ marginLeft: '32px' }}>
                      <img 
                        src={require('../shared/investments.png')} 
                        style={{ width: '200px' }} 
                        alt="sura" 
                      />
                    </div>
                    <div className="col col-nav-container">                    
                        <div className="nav-center-container">
                            <Navbar dark expand="lg">
                                <NavbarToggler onClick={this.toggleNav} />
                                <Collapse isOpen={this.state.isNavOpen} navbar>
                                    <Nav className="align-items-center" navbar>
                                        <NavItem>
                                            <NavLink className="nav-link" activeClassName="active" to="/home">
                                                Inicio
                                            </NavLink>
                                        </NavItem>
                                        {this.props.user_wm.data!==null ?
                                        <>
                                            {this.props.user_wm.data.services.includes("port_optim") || (this.props.user_wm.data.services.includes("port_saa") && this.props.user_wm.data.services.includes("load_portfolio")) ?
                                            <>
                                                <NavItem className="m-1">
                                                    <NavLink 
                                                        className="nav-link" 
                                                        to="/catalog"
                                                        isActive={(match, location) =>
                                                        location.pathname.startsWith("/catalog")
                                                        }
                                                        >
                                                            Catalogo
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem className="d-flex align-items-center m-1">
                                                    <div className="d-flex align-items-center">
                                                        <NavLink 
                                                            className="nav-link" 
                                                            to={this.props.user_wm.data.services.includes("port_optim") ? "/builder/fix" : "/builder/signature"}
                                                            isActive={(match, location) =>
                                                            location.pathname.startsWith("/builder/")
                                                            }
                                                            >
                                                                Builder
                                                        </NavLink>
                                                            <Dropdown
                                                              isOpen={this.state.isBuilderDropdownOpen}
                                                              toggle={() =>
                                                                this.setState({
                                                                  isBuilderDropdownOpen: !this.state.isBuilderDropdownOpen,
                                                                })
                                                              }
                                                              direction="down"
                                                            >
                                                              <DropdownToggle
                                                                tag="span"
                                                                caret={false}
                                                                aria-expanded={this.state.isBuilderDropdownOpen}
                                                                style={{ cursor: "pointer" }}
                                                              >
                                                                <i className="fa fa-chevron-down text-white" aria-hidden="true"></i>
                                                              </DropdownToggle>
                                                            
                                                              <DropdownMenu
                                                                className="dropdown-menu"
                                                                strategy="fixed" // replaces positionFixed
                                                                popperconfig={{
                                                                  modifiers: [
                                                                    { name: "preventOverflow", options: { boundary: "viewport" } },
                                                                    { name: "flip", options: { fallbackPlacements: ["bottom", "top"] } },
                                                                    { name: "computeStyles", options: { adaptive: false } },
                                                                  ],
                                                                }}
                                                              >
                                                                {this.props.user_wm.data.services.includes("port_optim") ?
                                                                <>
                                                                  <DropdownItem tag={RRNavLink} to="/builder/fix" activeClassName="active">
                                                                    Discrecional
                                                                  </DropdownItem>
                                                                  <DropdownItem
                                                                    tag={RRNavLink}
                                                                    to="/builder/optim/assets"
                                                                    activeClassName="active"
                                                                  >
                                                                    Optimización
                                                                  </DropdownItem>
                                                                </>
                                                                :null
                                                                }
                                                                <DropdownItem
                                                                  tag={RRNavLink}
                                                                  to="/builder/signature"
                                                                  activeClassName="active"
                                                                >
                                                                  TuRecomendación
                                                                </DropdownItem>
                                                                {this.props.user_wm.data.services.includes("port_optim") ?
                                                                <DropdownItem
                                                                  tag={RRNavLink}
                                                                  to="/builder/load"
                                                                  activeClassName="active"
                                                                >
                                                                  Carga manual
                                                                </DropdownItem>
                                                                : null}
                                                              </DropdownMenu>
                                                            </Dropdown>
                                                    </div>
                                                </NavItem>
                                            </>
                                            :null}
                                            {this.props.user_wm.data.services.includes("port_saa") && (this.props.user_wm.data.services.includes("port_metrics_mult") || this.props.user_wm.data.services.includes("port_backtest"))?
                                            <NavItem className="d-flex align-items-center m-1">
                                                <div className="d-flex align-items-center">
                                                    <NavLink 
                                                        className="nav-link" 
                                                        to={this.props.user_wm.data.services.includes("port_metrics_mult") ? "/portfolio/compar/params" : "/portfolio/backtest/params"}
                                                        isActive={(match, location) =>
                                                        location.pathname.startsWith("/portfolio/")
                                                        }
                                                        >
                                                            Portafolios Modelo
                                                    </NavLink>
                                                        <Dropdown
                                                          isOpen={this.state.isPortDropdownOpen}
                                                          toggle={() =>
                                                            this.setState({
                                                              isPortDropdownOpen: !this.state.isPortDropdownOpen,
                                                            })
                                                          }
                                                          direction="down"
                                                        >
                                                          <DropdownToggle
                                                            tag="span"
                                                            caret={false}
                                                            aria-expanded={this.state.isPortDropdownOpen}
                                                            style={{ cursor: "pointer" }}
                                                          >
                                                            <i className="fa fa-chevron-down text-white" aria-hidden="true"></i>
                                                          </DropdownToggle>
                                                        
                                                          <DropdownMenu
                                                            className="dropdown-menu"
                                                            strategy="fixed" // replaces positionFixed
                                                            popperconfig={{
                                                              modifiers: [
                                                                { name: "preventOverflow", options: { boundary: "viewport" } },
                                                                { name: "flip", options: { fallbackPlacements: ["bottom", "top"] } },
                                                                { name: "computeStyles", options: { adaptive: false } },
                                                              ],
                                                            }}
                                                          >
                                                            {this.props.user_wm.data.services.includes("port_metrics_mult") ?
                                                            <DropdownItem
                                                              tag={RRNavLink}
                                                              to="/portfolio/compar/params"
                                                              activeClassName="active"
                                                            >
                                                              Resumen de Portafolios
                                                            </DropdownItem>
                                                            :null
                                                            }
                                                            {this.props.user_wm.data.services.includes("port_backtest") ?
                                                            <DropdownItem
                                                              tag={RRNavLink}
                                                              to="/portfolio/backtest/params"
                                                              activeClassName="active"
                                                            >
                                                              Backtesting
                                                            </DropdownItem>
                                                            :null
                                                            }
                                                            {this.props.user_wm.data.services.includes("port_metrics_mult") && this.props.user_wm.data.services.includes("port_backtest") ?
                                                            <DropdownItem
                                                              tag={RRNavLink}
                                                              to="/portfolio/tactical"
                                                              activeClassName="active"
                                                            >
                                                              Análisis Táctico
                                                            </DropdownItem>
                                                            :null
                                                            }
                                                          </DropdownMenu>
                                                        </Dropdown>
                                                </div>
                                            </NavItem>
                                            :null}
                                            {this.props.user_wm.data.services.includes("query_client_portfolio") ?
                                            <NavItem className="d-flex align-items-center m-1">
                                                <div className="d-flex align-items-center">
                                                    <NavLink 
                                                        className="nav-link" 
                                                        to="/client_portfolio/stage/check"
                                                        isActive={(match, location) =>
                                                        location.pathname.startsWith("/client_portfolio/")
                                                        }
                                                        >
                                                            Gestión Portafolio Cliente
                                                    </NavLink>
                                                    <Dropdown
                                                      isOpen={this.state.isClientDropdownOpen}
                                                      toggle={() =>
                                                        this.setState({
                                                          isClientDropdownOpen: !this.state.isClientDropdownOpen,
                                                        })
                                                      }
                                                      direction="down"
                                                    >
                                                      <DropdownToggle
                                                        tag="span"
                                                        caret={false}
                                                        aria-expanded={this.state.isClientDropdownOpen}
                                                        style={{ cursor: "pointer" }}
                                                      >
                                                        <i className="fa fa-chevron-down text-white" aria-hidden="true"></i>
                                                      </DropdownToggle>
                                                    
                                                      <DropdownMenu
                                                        className="dropdown-menu"
                                                        strategy="fixed" // replaces positionFixed
                                                        popperconfig={{
                                                          modifiers: [
                                                            { name: "preventOverflow", options: { boundary: "viewport" } },
                                                            { name: "flip", options: { fallbackPlacements: ["bottom", "top"] } },
                                                            { name: "computeStyles", options: { adaptive: false } },
                                                          ],
                                                        }}
                                                      >
                                                        <DropdownItem
                                                          tag={RRNavLink}
                                                          to="/client_portfolio/load"
                                                          activeClassName="active"
                                                        >
                                                          Cargar Posiciones
                                                        </DropdownItem>
                                                        <DropdownItem
                                                          tag={RRNavLink}
                                                          to="/client_portfolio/stage/check"
                                                          activeClassName="active"
                                                        >
                                                          Análisis
                                                        </DropdownItem>
                                                      </DropdownMenu>
                                                    </Dropdown>
                                                </div>
                                            </NavItem>
    
    
                                            :null}
                                            {this.props.user_wm.data.services.includes("funds_selected") ?
                                            <NavItem>
                                                <NavLink className="nav-link" to="/fund_selection">
                                                    Selección de Fondos
                                                </NavLink>
                                            </NavItem>
                                            :null}
                                            {this.props.user_wm.data.services.includes("query_index_pc") ?
                                            <NavItem>
                                                <NavLink className="nav-link" to="/market_view">
                                                    Análisis de Mercado
                                                </NavLink>
                                            </NavItem>
                                            :null}
                                            {this.props.user_wm.data.services.includes("run_glue_job") ?
                                            <NavItem>
                                                <NavLink 
                                                    className="nav-link" 
                                                    to="/suitability"
                                                    isActive={(match, location) =>
                                                    location.pathname.startsWith("/suitability")}
                                                    >
                                                    Suitability
                                                </NavLink>
                                            </NavItem>
                                            :null}
                                            {this.props.user_wm.data.services.includes("retrieve_data_s3") && !(this.props.user_wm.data?.country=="PE" && this.props.user_wm.data?.depends_on?.length>0) ?
                                            <NavItem>
                                                <NavLink className="nav-link" to="/downloads">
                                                    Reportes
                                                </NavLink>
                                            </NavItem>
                                            :null}
                                        </>
                                    :<></>
                                    }
                                    </Nav>
                                    <Nav className="ml-auto align-items-center" navbar>
                                        <NavItem>
                                            <Button size='sm' className="header-btn" onClick={this.props.onLogout}>
                                                SignOut
                                            </Button>
                                        </NavItem>
                                    </Nav>
                                </Collapse>
                            </Navbar>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps)(Header));
